import Projects from '../projects/projects';

export default function ProjectsTab(props) {

    const dataInizio = props.dataInizio
    const dataFine = props.dataFine
    const intermediario = props.intermediario

return (
    <div>
        <Projects isInCompanyManage = {true} dataInizio = {dataInizio} dataFine = {dataFine} intermediario = {intermediario}></Projects>
    </div>
)};